export default class WebsocketConnectionError extends Error {
  event: Event;

  constructor(event: Event) {
    super("Websocket connection error");
    this.event = event;
  }
}
